module.exports = __webpack_public_path__ + "static/media/qr-hero.969f8c34.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/qr-hero.png
// module id = 369
// module chunks = 3